module.exports = "/dist/images/sl.7678f185.png";